import TemplateNames from './TemplateNames';

export default {
  title: 'Verzonden berichten',
  columns: {
    recipient: 'Ontvanger',
    template: 'Sjabloon',
    status: 'Status',
    opened: 'Geopend',
    clicked: 'Geklikt',
    sent_at: 'Verzonden op',
  },
  labels: {
    empty_list: 'Nog geen verzonden berichten',
    load_failed: 'Kon uw verzonden berichten niet laden. Laad de pagina opnieuw of neem contact op met de support.',
    yes: 'Ja',
    no: 'Nee',
    clicked_at: 'Geklikt op: {{date}}',
    opened_at: 'Geopend op: {{date}}',
  },
  message_statuses: {
    sent: 'Verzonden',
    delivered: 'Afgeleverd',
    failed: 'Mislukt',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
  },
};
